/**
 * デフォルトカラープリセット
 * 現行の色定義をそのまま維持
 */

import type { ColorPreset } from './types';

export const DEFAULT_PRESET: ColorPreset = {
  base: {
    WHITE: '#fff',
    BLACK: '#000',
    GRAY: '#8c8c8c',
    LIGHT_GRAY: '#f0f0f0',
    BORDER: '#b8b8b8',
    TEXT: 'rgba(0, 0, 0, 1)',
    TEXT_SECONDARY: 'rgba(0, 0, 0, 0.65)',
  },
  theme: {
    PRIMARY: '#1890ff',
    PRIMARY_DARK: '#096dd9',
    SUCCESS: '#52c41a',
    WARNING: '#faad14',
    ERROR: '#cc3e40',
    INFO: '#1890ff',
  },
  darkTheme: {
    BACKGROUND: '#001529',
    BORDER: '#002140',
    TEXT: '#fff',
  },
  status: {
    ACTIVE: '#52c41a',
    STOPPED: '#8c8c8c',
    WARNING: '#faad14',
    ERROR: '#cc3e40',
  },
  chart: {
    SERIES_1: '#cc3e40',
    SERIES_2: '#1890ff',
    SERIES_3: '#52c41a',
    SERIES_4: '#faad14',
    SERIES_5: '#722ed1',
    SERIES_6: '#13c2c2',
    SERIES_7: '#eb2f96',
    SERIES_8: '#b8393b',
    SERIES_9: '#d46b08',
    NO_DATA_MASK: 'rgba(128, 128, 128, 0.2)',
  },
  logLevel: {
    INFO: '#1890ff',
    WARNING: '#faad14',
    ERROR: '#cc3e40',
  },
  statistic: {
    TOTAL: '#1890ff',
    ACTIVE: '#52c41a',
    INACTIVE: '#8c8c8c',
    WARNING: '#faad14',
  },
  feedbackBackground: {
    ERROR_BG: '#ffccc7',
    ERROR_LIGHT: '#fff2f0',
    SUCCESS_LIGHT: '#f6ffed',
  },
} as const;
